module.exports = __webpack_public_path__ + "static/media/Rubik-Bold.938990e0.ttf";